/* eslint-disable camelcase */
/* eslint-disable no-restricted-globals */
import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import { callApi } from "../../api";
import { useAuth } from "../useAuth";

// const onlyUnique = (val, index, self) => self.indexOf(val) === index;

const usePaymentReports = () => {
  const [webPayments, setWebPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [payoutLoading, setPayoutLoading] = useState(false);
  const [payoutGridLoading, setPayoutGridLoading] = useState(false);

  const [payouts, setPayouts] = useState([]);
  const [payoutGrid, setPayoutGrid] = useState([]);

  const [stripeAccount, setStripeAccount] = useState();

  const { selectedBusiness } = useAuth();

  const showStripe = useMemo(() => {
    const temp =
      webPayments?.find((el) => el.Provider === "STRIPE") ||
      payouts?.length ||
      selectedBusiness?.info?.webpaymentProvider === "stripe";
    return !!temp;
  }, [webPayments, payouts]);

  const stripeWebPayoutsFormatted = useMemo(() => {
    // if (!webPayments) return [];
    // const temp1 = webPayments?.filter((x) => x.Provider === "STRIPE");
    // const uniquePayouts = temp1
    //   ?.map((x) => x["Payout Id"])
    //   .filter((x) => x)
    //   .filter(onlyUnique);
    // const temp2 = [];
    // uniquePayouts.forEach((po) => {
    //   const wps = webPayments.filter((el) => el["Payout Id"] === po);
    //   const reduced = wps.reduce(
    //     (a, b) => ({
    //       Amount: (+a.Amount || 0) + (+b.Amount || 0),
    //       Fee: (+a.Fee || 0) + (+b.Fee || 0),
    //     }),
    //     { Amount: 0, Fee: 0 }
    //   );
    //   temp2.push({ ...reduced, id: po });
    // });
    return (
      payouts?.map((el) => {
        const newTemp = {
          ...el,
          initiatedOn: moment
            .unix(el.created)
            .tz(selectedBusiness?.business?.timezone || "America/Los_Angeles")
            .format("YYYY-MM-DD HH:mm:ss"),
          arrivedAt: moment
            .unix(el.arrival_date)
            .tz(selectedBusiness?.business?.timezone || "America/Los_Angeles")
            .format("YYYY-MM-DD HH:mm:ss"),
          netamount:
            el.gross != null || el.fee != null
              ? +(el?.gross || 0) - +(el?.fee || 0)
              : null,
        };
        // const found = temp2.find((x) => x.id === el.id);
        if (+newTemp?.netamount === +el.amount) {
          return {
            ...newTemp,
            reconciled: true,
          };
        }
        return {
          ...newTemp,
          reconciled: false,
        };
      }) || []
    );
  }, [payouts]);

  const getPayoutData = async (po) => {
    const res1 = await callApi(
      `/protected/business/${selectedBusiness.id}/webpayments/payouts/${po}`,
      "GET"
    );
    if (res1?.status) {
      if (res1?.data?.payout) {
        setPayouts(
          payouts?.map((el) =>
            el?.id === po
              ? {
                  ...el,
                  gross: Math.round(res1?.data?.payout?.gross ?? el.gross),
                  fee: Math.round(res1?.data?.payout?.fee ?? el.fee),
                }
              : el
          )
        );
      } else if (res1?.data?.transactions?.length) {
        const summed = res1?.data?.transactions
          ?.map?.((x) => ({
            ...x,
            fee: Math.round((+x.fee || 0) * 100),
            gross: Math.round((+x.gross || 0) * 100),
          }))
          ?.reduce(
            (a, b) => ({
              gross: +a.gross + +b.gross,
              fee: +a.fee + +b.fee,
            }),
            { gross: 0, fee: 0 }
          );
        setPayouts(
          payouts?.map((el) =>
            el?.id === po
              ? {
                  ...el,
                  gross: summed?.gross ?? el.gross,
                  fee: summed?.fee ?? el.fee,
                }
              : el
          )
        );
      }
    }
    return res1;
  };

  const handleReconcilation = async (id, amount) => {
    try {
      const res = await getPayoutData(id);
      if (res?.status) {
        if (amount) {
          const summed = res?.data?.transactions
            ?.map?.((x) => ({
              ...x,
              fee: Math.round((+x.fee || 0) * 100),
              gross: Math.round((+x.gross || 0) * 100),
            }))
            ?.reduce(
              (a, b) => ({
                gross: +a.gross + +b.gross,
                fee: +a.fee + +b.fee,
              }),
              { gross: 0, fee: 0 }
            );
          const temp = res?.data?.payout || summed || {};
          if (amount !== +(temp.gross || 0) - (+temp.fee || 0)) {
            toast.error(
              "Transaction amount did not match stripe payout amount"
            );
          }
        }
      }
    } catch (err) {
      toast.error(err?.message || "Failed to fetch web payments data");
    }
  };

  const getPeriodWebPayments = async (period) => {
    setLoading(true);
    try {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/webpayments`,
        "GET",
        null,
        null,
        {
          start: period[0],
          end: period[1],
        }
      );
      if (res && res.status === true) {
        setWebPayments(res.data?.map?.((x) => ({ ...x, Amount: Math.round(x.Amount) })));
      } else {
        throw res;
      }
    } catch (err) {
      toast.error(err?.message || "Failed to fetch web payments data");
    }
    setLoading(false);
  };

  const getPeriodPayouts = async (period) => {
    setPayoutLoading(true);
    try {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/webpayments/payouts`,
        "GET",
        null,
        null,
        {
          start: period[0],
          end: period[1],
        }
      );
      if (res && res.status === true) {
        setPayouts(
          res.data?.map?.((x) => ({ ...x, gross: Math.round(x.gross) }))
        );
      } else {
        throw res;
      }
    } catch (err) {
      toast.error(err?.message || "Failed to fetch payout data");
    }
    setPayoutLoading(false);
  };

  const getPeriodPayoutGrid = async (period) => {
    setPayoutGridLoading(true);
    try {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/webpayments/payoutgrid`,
        "GET",
        null,
        null,
        {
          start: period[0],
          end: period[1],
        }
      );
      if (res && res.status === true) {
        setPayoutGrid(
          res.data?.map?.((x) => ({ ...x, gross: Math.round(x.gross) }))
        );
      } else {
        throw res;
      }
    } catch (err) {
      toast.error(err?.message || "Failed to fetch payout data");
    }
    setPayoutGridLoading(false);
  };

  const getPayoutsAllCharges = async ({ checkoutDay, payoutId }) => {
    try {
      const res = await callApi(
        `/protected/business/${selectedBusiness.id}/webpayments/allpayoutcharges`,
        "GET",
        null,
        null,
        {
          id: payoutId,
          checkout_day: checkoutDay,
        }
      );
      return res;
    } catch (err) {
      return null;
    }
  };

  const getStripeAccount = async () => {
    const res = await callApi(
      `/protected/business/${
        selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        ":BID:/stripe/payout/schedule/get"
      )}`
    );
    if (res?.status) {
      setStripeAccount(res.data);
    }
  };

  const updateStripeAccount = async ({
    delay_days,
    interval,
    weekly_anchor,
    monthly_anchor,
  }) => {
    const res = await callApi(
      `/protected/business/${
        selectedBusiness?.id
      }/iorequest?dest=${encodeURIComponent(
        ":BID:/stripe/payout/schedule/update"
      )}`,
      "POST",
      {
        schedule: { delay_days, interval, weekly_anchor, monthly_anchor },
      }
    );
    if (res?.status && res?.data) {
      setStripeAccount(res.data);
    }
    return res;
  };

  const showReceiptFromUrl = (url) => {
    const dualScreenLeft =
      typeof window.screenLeft !== "undefined"
        ? window.screenLeft
        : window.screenX;
    const dualScreenTop =
      typeof window.screenTop !== "undefined"
        ? window.screenTop
        : window.screenY;
    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;
    const left = width / 2 - 240 + dualScreenLeft;
    const top = height / 2 - 320 + dualScreenTop;

    window.open(
      url,
      "gzreceiptframe",
      `toolbar=no,scrollbar=yes,centerscreen=yes,chrome=yes,resizable=no,top=${top},left=${left},width=480,height=640`
    );
  };

  const getReceiptUrl = (tx) => {
    // const { hostname } = window.location;
    const isProd = process.env.REACT_APP_ENV === "production";
    // if (hostname === "accountv2.growthzilla.com") {
    //   isProd = true;
    // }
    const base = isProd ? "r.cpn.cm/" : "s.cpn.cm/";
    return `${window.location.protocol}//${base}b/${tx.business_id}/${tx.subscriber_id}/${tx.id}`;
  };

  const viewReceipt = (tx) => {
    if (tx && tx.checkout && tx.id) {
      const url = getReceiptUrl(tx);
      showReceiptFromUrl(url);
    }
  };

  const viewProviderReceipt = (tx) => {
    const url = tx && tx.receiptUrl;
    const hasValue = _.isString(url) ? url : url && url.value;
    if (hasValue) {
      return showReceiptFromUrl(hasValue);
    }
    toast.error("Receipt Not Available");
    return null;
  };

  const showOurReceipt = (row) => {
    const tx = {
      checkout: {
        subscriber_id: row["Customer#"],
      },
      business_id: selectedBusiness.id,
      subscriber_id: row["Customer#"],
      id: row.Invoice?.replace("INV", ""),
    };
    viewReceipt(tx);
  };

  const showTheirReceipt = (rowData) => {
    const provider = rowData && rowData.Provider;
    const isNmi = provider === "NMI";
    const providerTxId = isNmi && rowData.providerTxId;
    const { receipt } = rowData;
    const nmiReceipt = providerTxId
      ? `${`/growthzilla/remote/public/protected/business/${selectedBusiness.id}`}/nmireceipt/${providerTxId}`
      : "";
    const r = isNmi
      ? {
          receiptUrl: nmiReceipt,
        }
      : {
          receiptUrl: receipt,
        };
    viewProviderReceipt(r);
  };

  const disablePOS = (row) => {
    const tx = {
      checkout: {
        subscriber_id: row["Customer#"],
      },
      business_id: selectedBusiness.id,
      subscriber_id: row["Customer#"],
      id: row.Invoice?.replace("INV", ""),
    };
    return !tx.business_id || !tx.subscriber_id || !tx.id;
  };

  const disableProvider = (rowData) => {
    const provider = rowData && rowData.Provider;
    const isNmi = provider === "NMI";
    const providerTxId = isNmi && rowData.providerTxId;
    const { receipt } = rowData;
    const nmiReceipt = providerTxId
      ? `${`/growthzilla/remote/public/protected/business/${selectedBusiness.id}`}/nmireceipt/${providerTxId}`
      : "";
    const r = isNmi
      ? {
          receiptUrl: nmiReceipt,
        }
      : {
          receiptUrl: receipt,
        };
    const url = r && r.receiptUrl;
    const hasValue = _.isString(url) ? url : url && url.value;
    return !hasValue;
  };

  useEffect(() => {
    setWebPayments([]);
    setPayoutGrid([]);
    setPayouts([]);
  }, [selectedBusiness?.id]);

  return {
    webPayments,
    loading,
    payoutLoading,
    payouts: stripeWebPayoutsFormatted,
    showStripe,
    payoutGridLoading,
    payoutGrid,
    getPeriodPayouts,
    getPayoutData,
    getPeriodWebPayments,
    showOurReceipt,
    showTheirReceipt,
    disablePOS,
    disableProvider,
    handleReconcilation,
    stripeAccount,
    getStripeAccount,
    getPeriodPayoutGrid,
    updateStripeAccount,
    getPayoutsAllCharges,
  };
};

export default usePaymentReports;
